var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0845",
    d: "M11.262 17.97c-2.333 0-4.231-1.899-4.231-4.232s1.898-4.232 4.23-4.232c2.335 0 4.232 1.899 4.232 4.232s-1.897 4.231-4.231 4.231zM19 6.516v-.002c0-.008-.004-.015-.005-.024a.537.537 0 00-.034-.172.513.513 0 00-.088-.133c-.009-.01-.012-.024-.022-.034h-.001a.515.515 0 00-.363-.152h-3.304a.514.514 0 100 1.031h2.052l-2.649 2.632a5.236 5.236 0 00-3.324-1.188A5.27 5.27 0 006 13.738 5.268 5.268 0 0011.262 19a5.268 5.268 0 005.262-5.262 5.24 5.24 0 00-1.206-3.349l2.652-2.635v2.063a.514.514 0 101.03 0v-3.3z"
  })));
}
export default SvgMale;